//These extenders try to mimic Knockout.Validation. Knockout.Validation is not used because the 'isValid' method, that is added to every field, that should be
//validated, is not an observable. For that reason you cannot use it in Knockout bindings. Even if that would be the case, you would not have a way to trigger
//the validation.

ko.extenders.required = function(target, options) {
    return validateOnlyIfForbiddingEmptyValue(target, options, function(val, required) {
        required = getValueIfObservable(required);
        if (!required) {
            return true;
        }
        if (typeof val === "string" && val.trim() !== "") {
            return true;
        }
        if (typeof val === "boolean" && val === true) {
            return true;
        }
        if (typeof val === "number" && val >= 0) {
            return true;
        }
        return false;
    });
};

ko.extenders.email = function(target, options) {
    return validateOnlyIfAllowingEmptyValue(target, options, function(val, validateEmail) {
        validateEmail = getValueIfObservable(validateEmail);
        if (!validateEmail) {
            return true;
        }
        return isValidEmailAddress(val);
    });
};

ko.extenders.min = function(target, options) {
    return validateOnlyIfAllowingEmptyValue(target, options, function(val, minValue) {
        if (!isNumber(val)) {
            return false;
        }
        minValue = getValueIfObservable(minValue);
        return parseFloat(val) >= minValue;
    });
};

ko.extenders.max = function(target, options) {
    return validateOnlyIfAllowingEmptyValue(target, options, function(val, maxValue) {
        if (!isNumber(val)) {
            return false;
        }
        maxValue = getValueIfObservable(maxValue);
        return parseFloat(val) <= maxValue;
    });
};

ko.extenders.minLength = function(target, options) {
    return validateOnlyIfAllowingEmptyValue(target, options, function(val, minLength) {
        minLength = getValueIfObservable(minLength);
        return val.length >= minLength;
    });
};

ko.extenders.equal = function(target, options) {
    return validateOnlyIfAllowingEmptyValue(target, options, function(val, otherValue) {
        otherValue = getValueIfObservable(otherValue);
        return val === otherValue;
    });
};

ko.extenders.beforeDate = function(target, options) {
    return validateOnlyIfAllowingEmptyValue(target, options, function(val, latestPossibleDate) {
        var valueAsDate = parseDate(val);
        if (isNaN(valueAsDate)) {
            return false;
        }
        latestPossibleDate = getValueIfObservable(latestPossibleDate);
        return valueAsDate <= latestPossibleDate;
    });
};

ko.extenders.validation = function(target, options) {
    return validateOnlyIfAllowingEmptyValue(target, options, function(val, validationObject) {
        return validationObject.validator(val);
    });
};

function validateOnlyIfForbiddingEmptyValue(target, options, validationFunction) {
    return validateOnlyIf(target, options, validationFunction, false);
}

function validateOnlyIfAllowingEmptyValue(target, options, validationFunction) {
    return validateOnlyIf(target, options, validationFunction, true);
}

function validateOnlyIf(target, options, validationFunction, allowEmptyValue) {
    setupTarget(target, function(val) {
        var executeValidation = evaluateOnlyIf(options.onlyIf);
        if (!executeValidation) {
            return true;
        }
        if (allowEmptyValue && val === "") {
            return true;
        }
        var params = (typeof options.params === "undefined") ? options : options.params;
        var validationResult = validationFunction(val, params);
        target.hasError(!validationResult);
        return validationResult;
    });
    return target;
}

function setupTarget(target, validateFunction) {
    target.hasError = ko.observable(false);
    if (!Array.isArray(target.validateFunctions)) {
        target.validateFunctions = [];
        target.validate = function(val) {
            for (var i = 0; i < target.validateFunctions.length; i++) {
                var validateFunction = target.validateFunctions[i];
                var validateFunctionResult = validateFunction(val);
                if (!validateFunctionResult) {
                    return;
                }
            }
        };
        target.subscribe(target.validate);
    }
    target.validateFunctions.push(validateFunction);
}

function evaluateOnlyIf(onlyIf) {
    if (typeof onlyIf !== "function") {
        return true;
    }
    return onlyIf();
}

function getValueIfObservable(val) {
    if (typeof val === "function") {
        return val();
    }
    return val;
}

function isNumber(value) {
    return !isNaN(parseFloat(value)) && isFinite(value);
}

//Months as words are not supported. Times are not supported. Years must be formatted as YYYY. Separators must be "-", "." or "/".
function parseDate(dateString) {
    var intMatches = /(\d+)\D(\d+)\D(\d+)/.exec(dateString.trim());
    //length > 4 because match[0] is the complete match
    if (intMatches == null || intMatches.length !== 4) {
        return NaN;
    }

    var day = undefined;
    var dayPosition = undefined;
    var year = undefined;
    var yearPosition = undefined;
    var datePartsInOrder = [parseInt(intMatches[1]), parseInt(intMatches[2]), parseInt(intMatches[3])];
    for (var i = 0; i < datePartsInOrder.length; i++) {
        var currentDatePart = datePartsInOrder[i];
        if (currentDatePart > 999) {
            if (year !== undefined) {
                return NaN;
            }
            year = currentDatePart;
            yearPosition = i;
        }
        if (currentDatePart > 12 && currentDatePart <= 31) {
            if (day !== undefined) {
                return NaN;
            }
            day = currentDatePart;
            dayPosition = i;
        }
    }

    //No 4 digit date part or year in the middle
    if (year === undefined || yearPosition === 1) {
        return NaN;
    }
    //We found the day, because a date part was between 13 and 31 and hence must be the day
    if (day !== undefined) {
        var month;
        for (var i = 0; i < datePartsInOrder.length; i++) {
            if (i !== dayPosition && i !== yearPosition) {
                month = datePartsInOrder[i];
            }
        }
        return createDate(year, month, day);
    }
    //We did not find the day but the day part and the month part are equal
    if (yearPosition === 0 && datePartsInOrder[1] === datePartsInOrder[2] || yearPosition === 2 && datePartsInOrder[0] === datePartsInOrder[1]) {
        return createDate(year, datePartsInOrder[1], datePartsInOrder[1]);
    }

    var uniqueSeparators = getDateSeparators(dateString);
    //Date with different separators
    if (uniqueSeparators.length !== 1) {
        return NaN;
    }
    var separator = uniqueSeparators[0];
    if (yearPosition === 0) {
        //i.e. yyyy-mm-dd or yyyy.mm.yy or yyyy/mm/dd - sorry Kazakhstan; apparently dates are sometimes written yyyy.dd.mm there
        return createDate(year, datePartsInOrder[1], datePartsInOrder[2]);
    } else if (yearPosition === 2) {
        if (separator === "-" || separator === ".") {
            //i.e. dd-mm-yyyy or dd.mm.yyyy
            return createDate(year, datePartsInOrder[1], datePartsInOrder[0]);
        } else if (separator === "/") {
            //i.e. mm/dd/yyyy
            return createDate(year, datePartsInOrder[0], datePartsInOrder[1]);
        }
    }
    return NaN;
}

function getDateSeparators(dateString) {
    var separatorMatch = /(\D)/.exec(dateString);
    var separatorMatchesArray = [];
    for (var i = 1; i < separatorMatch.length; i++) {
        separatorMatchesArray.push(separatorMatch[i]);
    }
    var uniqueSeparators = separatorMatchesArray.filter(function(value, index, self) {
        return self.indexOf(value) === index;
    })
    return uniqueSeparators;
}

function createDate(year, month, day) {
    var monthIndex = month - 1;
    var createdDate = new Date(year, monthIndex, day);
    //Dates in JavaScript are lenient. 30.02.2020 is automatically converted to 01.03.2020.
    //So we check if the date after creation has the same properties that we passed initially.
    if (createdDate.getFullYear() !== year || createdDate.getMonth() !== monthIndex || createdDate.getDate() !== day) {
        return NaN;
    }
    return createdDate;
}

function isValidEmailAddress(email) {
    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
}
